// useCase can be "media", "analytic", "table"
import { FiImage } from "react-icons/fi";
import { RiBarChart2Line, RiErrorWarningLine } from "react-icons/ri";
import { HiOutlineClipboardList } from "react-icons/hi";

function EmptyBox({
  size = 16,
  color = "rgb(171 169 169)",
  useCase = "media",
  style = {},
}) {
  if (useCase === "media") {
    return <FiImage size={size} color={color} style={style} />;
  }

  if (useCase === "analytic") {
    return <RiBarChart2Line size={size} color={color} style={style} />;
  }

  if (useCase === "table") {
    return <HiOutlineClipboardList size={size} color={color} style={style} />;
  }

  if (useCase === "error") {
    return <RiErrorWarningLine size={size} color={color} style={style} />;
  }
}

export default EmptyBox;
